import { type CapgoReasonClass, isDiskReason, isLowNetworkReason } from './capgoReason';

export type GateHint = 'disk_full' | 'low_network';

export interface GateHintInput {
  reason?: CapgoReasonClass;
  consecutiveFailures: number;
  attemptDurationMs?: number;
  lastProgressPercent?: number;
}

const LOW_NETWORK_DURATION_MS = 30_000;

export const classifyGateHint = (input: GateHintInput): GateHint | null => {
  const { reason, consecutiveFailures, attemptDurationMs, lastProgressPercent } = input;
  if (reason !== undefined && isDiskReason(reason)) return 'disk_full';
  if (consecutiveFailures < 2) return null;
  if (reason !== undefined && isLowNetworkReason(reason)) return 'low_network';
  const reasonUnknown = reason === undefined || reason === 'android_no_reason';
  if (!reasonUnknown) return null;
  const noProgress = lastProgressPercent === undefined || lastProgressPercent === 0;
  if (attemptDurationMs !== undefined && attemptDurationMs >= LOW_NETWORK_DURATION_MS && noProgress) {
    return 'low_network';
  }
  return null;
};
